module.exports = __webpack_public_path__ + "img/scar.cc9d9946.svg";